export enum BlogError {
	BLOG_ERROR = 'There was an error loading Blog. Please try again.',
	DELETE_ERROR = 'Error deleting Blog',
	EDIT_ERROR = 'Error editing Blog',
	CREATE_ERROR = 'Error creating Blog',
	NAME_ERROR = 'Blog name is required',
	DESCRIPTION_ERROR = 'Blog description is required',
}